<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    id="setting-panel"
    class="com-map-menu pa-2"
    :viewMode="isPcMode ? 'pc' : 'mb'"
    :showToPc="!isPcMode && showToPc ? 'true' : 'false'"
  >
    <v-col class="pb-0">
      <v-row v-if="!isPcMode">
        <v-tooltip top v-model="showTtLegend" :disabled="stopTtLegend">
          <template v-slot:activator="{ on }">
            <v-btn
              v-show="isPcMode || (!isPcMode && isNotPlay)"
              depressed
              icon
              class="color-change-off setting-btn-mb setting-legend"
              v-on="on"
              @click="showLegend"
              :class="{ 'btn-on': btnOnFlg }"
              :isPc="!isPcMode && isNotPlay && showToPc"
              aria-label="はんれい"
            >
              <v-icon>list_alt</v-icon>
            </v-btn>
          </template>
          <span>{{ text.legend }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-show="isPcMode && isNotPlay"
              depressed
              fab
              small
              class="ms-2 setting-btn-mb"
              v-on="on"
              @click="toMobile"
              aria-label="モバイルモードにきりかえる"
            >
              <v-icon>mobile_screen_share</v-icon>
            </v-btn>
          </template>
          <span>{{ text.toMobile }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-show="!isPcMode && isNotPlay && showToPc"
              depressed
              fab
              small
              class="ms-2 setting-btn-mb"
              v-on="on"
              @click="toPc"
              :isPc="!isPcMode && isNotPlay && showToPc"
              aria-label="PCモードにきりかえる"
            >
              <v-icon>screen_share</v-icon>
            </v-btn>
          </template>
          <span>{{ text.toPc }}</span>
        </v-tooltip>
        <!-- <v-tooltip top v-model="showTtVg" :disabled="stopTtVg">
          <template v-slot:activator="{ on }">
            <v-btn
              v-show="isNotPlay"
              depressed
              fab
              small
              class="ms-2 color-change-off"
              color="success"
              v-on="on"
              @click="showViewGroup"
            >
              <v-icon>build</v-icon>
            </v-btn>
          </template>
          <span>{{ text.viewGroup }}</span>
        </v-tooltip> -->
      </v-row>

      <v-row align="center" v-if="isPcMode">
        <v-btn
          v-show="isPcMode || (!isPcMode && isNotPlay)"
          depressed
          class="setting-btn"
          color="success"
          @click="showLegend()"
        >
          {{ text.legend }}
        </v-btn>
        <v-btn
          v-show="isPcMode && isNotPlay"
          depressed
          class="setting-btn"
          color="success"
          @click="toMobile"
        >
          {{ text.toMobile }}
        </v-btn>
        <v-btn
          v-show="isNotPlay"
          depressed
          class="setting-btn"
          color="success"
          @click="showViewGroup"
        >
          {{ text.viewGroup }}
        </v-btn>
      </v-row>
    </v-col>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 設定パネル
 * SettingPanel.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import PageLog from "./../../lib/pageLog.js";

export default {
  name: "map-setting-panel",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        legend: "凡例",
        viewGroup: "表示切替",
        toPc: "PCモード",
        toMobile: "モバイルモード",
      },
      /** PCモード切替ボタンの表示有無 */
      showToPc: true,
      /** ツールチップの表示有無 */
      showTtLegend: false,
      showTtVg: false,
      /** ツールチップ用タイマー */
      timeId: null,
      stopTtLegend: false,
      stopTtVg: false,
      /** ボタン押下時のCSS用 */
      btnOnFlg: false,
    };
  },
  mounted() {
    // 画面が縦長の場合、簡易版起動の場合はPCモード変更ボタンを非表示にする
    if (
      window.innerWidth < window.innerHeight ||
      global.KWB_MODE == "reduction"
    ) {
      this.showToPc = false;
    }
  },
  computed: {
    /** 表示モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode === "pc";
      },
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlay: {
      get() {
        return this.$store.getters["radar/isNotPlay"];
      },
    },
    showLegendFlg: {
      get() {
        return this.$store.state.map.showLegend;
      },
    },
    /* 過去画像再生ボタン押下フラグ */
    historyImageMovieFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.historyImageMovieFlg;
      },
    },
    /* スライド終了時刻 */ 
    setTime: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.movieEndTime;
      },
    }
  },
  methods: {
    /** 地図凡例ダイアログの表示/非表示 */
    showLegend() {
      clearTimeout(this.timeId);
      // ツールチップの開閉
      if (!this.showLegendFlg && !this.showTtLegend) {
        this.stopTtLegend = false;
        this.showTtLegend = true;
        this.timeId = setTimeout(() => {
          this.showTtLegend = false;
        }, 3000);
        // ツールチップが閉じてダイアログが表示されている場合、ツールチップを無効にする
      } else if (this.showLegendFlg && !this.showTtLegend) {
        this.stopTtLegend = true;
      } else {
        this.showTtLegend = false;
      }
      if (this.$store.state.app.mode == "mb" && !this.showLegendFlg) {
        // 地図上のダイアログを全て非表示
        this.$store.commit("map/dialogAllClose");
        // モバイルモード初期表示(全てのダイアログを非表示)
        this.routerPush("/mb");
        this.$store.commit("app/setContent", "");
      }
      this.$store.commit("map/setShowLegend", !this.showLegendFlg);
    },
    /** 表示グループ設定ダイアログの表示/非表示 */
    showViewGroup() {
      clearTimeout(this.timeId);
      // ツールチップを開く
      if (!this.$store.state.map.showViewGroup && !this.showTtVg) {
        this.stopTtVg = false;
        this.showTtVg = true;
        this.timeId = setTimeout(() => {
          this.showTtVg = false;
        }, 3000);
        // ツールチップが閉じてダイアログが表示されている場合、ツールチップを無効にする
      } else if (this.$store.state.map.showViewGroup && !this.showTtVg) {
        this.stopTtVg = true;
      } else {
        this.showTtVg = false;
      }
      if (
        this.$store.state.app.mode == "mb" &&
        !this.$store.state.map.showViewGroup
      ) {
        // 地図上のダイアログを全て非表示
        this.$store.commit("map/dialogAllClose");
        // モバイルモード初期表示(全てのダイアログを非表示)
        this.routerPush("/mb");
        this.$store.commit("app/setContent", "");
      }
      this.$store.commit(
        "map/setShowViewGroup",
        !this.$store.state.map.showViewGroup
      );
    },
    /** PCモード移行 */
    toPc() {
      // アクセスログ出力
      PageLog.log({
        page_log: "pc_mob",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.routerPushChangePc(this.$route.path);
    },
    /** モバイルモード移行 */
    toMobile() {
      // アクセスログ出力
      PageLog.log({
        page_log: "pc_mob",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.routerPushChangeMb(this.$route.path);
    },
  },
  watch: {
    showLegendFlg() {
      if (this.showLegendFlg) {
        this.btnOnFlg = true;
      } else {
        this.btnOnFlg = false;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
@import "./../../scss/_media_query.scss";

#setting-panel {
  position: absolute;
  z-index: 3050;
  bottom: 0;
  &[viewMode="mb"] {
    &[showToPc="false"] {
      right: 0;
    }
  }
  &[showToPc="true"] {
    left: 160px;
  }
  .setting-btn {
    height: 30px;
    width: 120px;
    margin-right: 8px;
  }
  .setting-btn-mb {
    height: 40px;
    width: 40px;
    background: {
      color: $concept-color !important;
    }
    .v-icon {
      color: white;
    }
    &:focus {
      background-color: $concept-color-pale !important;
      &::before {
        opacity: 0 !important;
      }
      .v-icon {
        color: $concept-color;
      }
    }
    &[isPc="true"] {
      &:hover {
        background-color: $concept-color-pale !important;
        &::before {
          opacity: 0 !important;
        }
        .v-icon {
          color: $concept-color;
        }
      }
    }
  }
  .btn-on {
    background-color: $concept-color-pale !important;
    .v-icon {
      color: $concept-color;
    }
  }
  .color-change-off::before {
    background-color: unset;
  }
}
</style>
